import { useMemo, type FC } from 'react'
import clsx from 'clsx'

import { Shimmer } from '@wartek-id/shimmer'

import FilterButtons from 'app/KinerjaShared/components/FilterButtons'
import {
  pelaksanaanStateKey,
  pelaksanaanStateLabel,
} from 'app/KinerjaKSPage/utils/states'

import type {
  PelaksanaanStateFilter,
  PengawasSchoolMeta,
} from 'types/kinerja-ks-pelaksanaan'

export type FileItem = {
  label: string
  value: Array<PelaksanaanStateFilter>
}

type HeadmasterFilterItems = Array<FileItem>

type Props = {
  isLoading?: boolean
  counts: PengawasSchoolMeta['counts']
  activeFilter?: Array<PelaksanaanStateFilter>
  onChange?: (value: Array<PelaksanaanStateFilter>) => void
  className?: string
}

const FilterSekolah: FC<Props> = ({
  isLoading,
  counts,
  activeFilter,
  onChange,
  className,
}) => {
  const filterItems: HeadmasterFilterItems = useMemo(() => {
    return [
      { value: ['ALL'] },
      { value: ['OBSERVATION'] },
      { value: ['FOLLOW_UP', 'FOLLOW_UP_EVALUATION'] },
      {
        value: ['REFLECTION_FOLLOW_UP', 'REFLECTION_FOLLOW_UP_EVALUATION'],
      },
      { value: ['COMPLETED'] },
    ].map((item: FileItem) => {
      const label = pelaksanaanStateLabel(item?.value?.[0])

      const counter = !!counts
        ? item?.value?.reduce((acc, curr) => {
            return acc + counts?.[pelaksanaanStateKey(curr)] || 0
          }, 0)
        : null

      return {
        ...item,
        label: `${label}${counter >= 0 ? ` (${counter})` : ''}`,
      }
    })
  }, [counts])

  return (
    <div className={clsx('px-5', className)}>
      {isLoading && (
        <div className="flex gap-4">
          {Array.from({ length: 5 })?.map((_, index) => (
            <Shimmer
              width={90 + index * 20}
              height={28}
              className="!rounded-full"
              key={index}
            />
          ))}
        </div>
      )}

      {!isLoading && (
        <FilterButtons
          items={filterItems}
          activeValue={activeFilter}
          btnSize="sm"
          onChange={(value) => onChange?.(value)}
        />
      )}
    </div>
  )
}
export default FilterSekolah
